import { render, staticRenderFns } from "./Opz2SettingsPane.vue?vue&type=template&id=6da024de"
import script from "./Opz2SettingsPane.vue?vue&type=script&lang=ts"
export * from "./Opz2SettingsPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports